import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class ContactKeyQueryCriteriaClass extends BaseCriteriaModel {
  //for extension & line
  ext_param_code?: Optional<string> = Optional.empty();
  ext_param_name?: Optional<string> = Optional.empty();
  ext_param_type?: Optional<string> = Optional.empty();
  ext_value_string?: Optional<string> = Optional.empty();
  ext_value_numeric?: Optional<number> = Optional.empty();
  ext_value_datetime?: Optional<string> = Optional.empty();
  line_param_code?: Optional<string> = Optional.empty();
  line_param_name?: Optional<string> = Optional.empty();
  line_param_type?: Optional<string> = Optional.empty();
  line_value_string?: Optional<string> = Optional.empty();
  line_value_numeric?: Optional<number> = Optional.empty();
  line_value_datetime?: Optional<string> = Optional.empty();
}

export class ContactKeyCriteriaModelQuery {
  query = '';

  constructor(contactKeyCriteriaModel: ContactKeyQueryCriteriaClass) {

    if (!contactKeyCriteriaModel) {
      return;
    }

    this.query += contactKeyCriteriaModel.ext_param_code.filter(x => x !== '').map(x => '&ext_param_code=' + x).orElse('');
    this.query += contactKeyCriteriaModel.ext_param_name.filter(x => x !== '').map(x => '&ext_param_name=' + x).orElse('');
    this.query += contactKeyCriteriaModel.ext_param_type.filter(x => x !== '').map(x => '&ext_param_type=' + x).orElse('');
    this.query += contactKeyCriteriaModel.ext_value_string.filter(x => x !== '').map(x => '&ext_value_string=' + x).orElse('');
    this.query += contactKeyCriteriaModel.ext_value_numeric.filter(x => x !== null).map(x => '&ext_value_numeric=' + x).orElse('');
    this.query += contactKeyCriteriaModel.ext_value_datetime.filter(x => x !== '').map(x => '&ext_value_datetime=' + x).orElse('');
    this.query += contactKeyCriteriaModel.line_param_code.filter(x => x !== '').map(x => '&line_param_code=' + x).orElse('');
    this.query += contactKeyCriteriaModel.line_param_name.filter(x => x !== '').map(x => '&line_param_name=' + x).orElse('');
    this.query += contactKeyCriteriaModel.line_param_type.filter(x => x !== '').map(x => '&line_param_type=' + x).orElse('');
    this.query += contactKeyCriteriaModel.line_value_string.filter(x => x !== '').map(x => '&line_value_string=' + x).orElse('');
    this.query += contactKeyCriteriaModel.line_value_numeric.filter(x => x !== null).map(x => '&line_value_numeric=' + x).orElse('');
    this.query += contactKeyCriteriaModel.line_value_datetime.filter(x => x !== '').map(x => '&line_value_datetime=' + x).orElse('');

    this.query += '&status=' + contactKeyCriteriaModel.status;
    this.query += '&orderBy=' + contactKeyCriteriaModel.orderBy;
    this.query += '&order=' + contactKeyCriteriaModel.order;
    this.query += '&offset=' + contactKeyCriteriaModel.offset + '&limit=' + contactKeyCriteriaModel.limit;
  }
}
